// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nKvYht2t4VfFRolvwRqP {
	align-items: center;
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: center;
	width: 100%;
}
@media (max-width: 767px) {
	.nKvYht2t4VfFRolvwRqP {
		align-items: stretch;
		justify-content: space-between;
}
	}
`, "",{"version":3,"sources":["webpack://./src/layouts/DefaultLayout/DefaultLayout.pcss"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,OAAO;CACP,uBAAuB;CACvB,WAAW;AAMZ;AAJC;CARD;EASE,oBAAoB;EACpB,8BAA8B;AAEhC;CADC","sourcesContent":["@import '../../stylesheets/media-queries.pcss';\n\n.layout {\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tjustify-content: center;\n\twidth: 100%;\n\n\t@media (--mobile) {\n\t\talign-items: stretch;\n\t\tjustify-content: space-between;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `nKvYht2t4VfFRolvwRqP`
};
export default ___CSS_LOADER_EXPORT___;
